<template>
    <div class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i>运营</el-breadcrumb-item>
                <el-breadcrumb-item>礼包码</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='22'>
                        <el-form ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item label='项目'>
                                <el-select @change='handleSelectProject' clearable size='mini'
                                           v-model='queryParams.projectAppId' filterable placeholder='请选择'>
                                    <el-option
                                        v-for='item in projectInfoList'
                                        :key='item.appId'
                                        :label='item.cnName'
                                        :value='item.appId'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>确定
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
            
            <el-collapse v-if='queryParams.projectAppId' accordion v-model='activeNames'>
                <el-collapse-item title='' name='empty'>
                    <single-gift-group-code :project-app-id='queryParams.projectAppId'
                                            :admin-user-list='adminUserList'
                                            :project-info-list='projectInfoList'
                                            @refreshGroupList='handleRefreshGroup'
                                            :active-panel='activeNames === "empty"' />
                </el-collapse-item>
                <el-collapse-item v-for='item in groupList' :key='item.id' :title='item.name' :name='item.id'>
                    <single-gift-group-code :project-app-id='queryParams.projectAppId'
                                            :admin-user-list='adminUserList'
                                            :project-info-list='projectInfoList'
                                            :group-id='item.id'
                                            @refreshGroupList='handleRefreshGroup'
                                            :active-panel='activeNames === item.id'
                                            :group-name='item.name' />
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>

<script>
import { pageUtil } from '@/utils/pageUtil';
import { queryProjectInfoList } from '@api/ProjectInfo';
import { giftCodeGroupApi } from '@api/operation/giftCode/giftCodeGroup';
import { cottonUserApi } from '@api/Account/userCotton';
import { message } from '@/utils/message';
import { selectEmployeeList } from '@api/dashboard';
import SingleGiftGroupCode from '@view/operation/giftCode/SingleGiftGroupCode.vue';

export default {
    name: 'GiftCodeManage',
    components: { SingleGiftGroupCode },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 总条数
            total: 0,
            // 弹出层标题
            title: '',
            updateStatus: false,
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
                
                projectAppId: undefined,
                name: undefined
            },
            
            projectInfoList: [],
            adminUserList: [],
            redeemStatusOptions: [
                {
                    label: '成功',
                    value: true
                },
                {
                    label: '失败',
                    value: false
                }
            ],
            redemptionRecordList: [],
            openShowUserInfoStatus: false,
            currentShowUserInfo: {},
            activeNames: 'empty',
            groupList: [],
            currentGroup: {}
        };
    },
    computed: {
        computeIsAccountUser() {
            return userId => {
                return userId && userId.startsWith('userId_');
            };
        },
        computeRealUserId() {
            return userId => {
                return userId.substring('userId_'.length);
            };
        }
    },
    created() {
        this.initData();
        if (this.queryParams.projectAppId) {
            this.getList();
        }
    },
    methods: {
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size;
            this.queryParams.pageNum = 1;
            this.getList();
        },
        async handleSortChange({ column, prop, order }) {
            await pageUtil.handleSortChange(prop, order, this.queryParams.sortSqlList);
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 15;
            this.getList();
        },
        initData() {
            this.adminUserList = [];
            selectEmployeeList({ pageSize: 10000 }).then(result => {
                this.adminUserList = result.data;
            });
            // 获取所有的项目组
            queryProjectInfoList({ pageSize: 10000 }).then(result => {
                this.projectInfoList = result.data.result;
            });
        },
        getList() {
            this.loading = true;
            giftCodeGroupApi.query(this.queryParams).then(result => {
                if (result.code === 200) {
                    this.groupList = result.data.result;
                    this.queryParams.total = result.data.total;
                    this.queryParams.pageNum = result.data.pageNum;
                    this.queryParams.pageSize = result.data.pageSize;
                }
                this.loading = false;
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList();
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ]
            };
            this.handleQuery();
        },
        resetQueryPage() {
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 15;
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.userId);
            this.updateStatus = true;
        },
        /** 新增按钮操作 */
        handleAdd() {
        
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
        
        },
        /** 删除按钮操作 */
        handleDelete(row) {
        
        },
        /** 提交按钮 */
        submitForm: function() {
        
        },
        handleSelectProject(projectAppId) {
            this.getList();
        },
        handleQueryUserInfo(userId) {
            this.currentShowUserInfo = {};
            cottonUserApi.queryUserCotton({ userId: userId }).then(result => {
                if (result.code === 200) {
                    let dataList = result.data.result;
                    if (!dataList || dataList.length === 0) {
                        message.error(`用户${userId}不存在, 可能原因: 该账号已被注销！`);
                    } else {
                        this.openShowUserInfoStatus = true;
                        this.currentShowUserInfo = dataList[0];
                    }
                }
            });
        },
        handleBlurAccountInput(account) {
            cottonUserApi.queryUserCotton({ account: account }).then(result => {
                if (result.code === 200) {
                    let dataList = result.data.result;
                    if (dataList && dataList.length !== 0) {
                        this.queryParams.userId = 'userId_' + dataList[0].userId;
                    } else {
                        this.queryParams.userId = undefined;
                    }
                }
            });
        },
        handleGroupChange() {
        },
        handleRefreshGroup() {
            this.getList();
        }
    }
};
</script>

<style scoped lang='scss'>

</style>
